import { z } from 'zod';
import { idSchema, timestamps } from './utility';

export const claimSchema = z.object({
  id: idSchema,
  parent_id: idSchema.nullable(),
  uuid: z.string(),
  payee_case_id: idSchema,
  claim_type_id: idSchema.nullable(),
  claim_type_specification: z.string().nullable(),
  ref_id: z.string().nullable(),
  paid_amount: z.number().int(),
  original_amount: z.number().int(),
  due_date_at: z.string().nullable(),
  ...timestamps,
});
export type Claim = z.infer<typeof claimSchema>;